export function formatInchesToFeet(inches: number) {
  const feet = Math.floor(inches / 12);
  const remainder = inches % 12;
  return `${feet}'` + (remainder > 0 ? `${remainder}"` : "");
}
